import React from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../components/ui/Icon";

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="page page--narrow">
            <div className="card card-pad">
                <div className="empty-state">
                    <Icon name="leaf"/>
                    <strong>Page not found</strong>
                    <span>The page you were looking for does not exist.</span>
                    <button className="btn btn-primary" style={{marginTop: "0.6rem"}} onClick={() => navigate("/")}>
                        Back to the front page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
